import React,{Component} from 'react';


class About extends Component{
    render(){
        return(
        <div>
            <h1 style={{textAlign:'center'}}>ABOUT ME</h1>
            <h5 style={{float:'left', textDecorationColor:'black'}}> I am a hard-working individual looking for opportunities in the Software Engineering or Web development field.With pursuing Master’s degree in Computer Science,and hands-on experience in building Web Technologies like Javascript,Jquery,React.js,HTML,CSS ,ES6,Redux.
               
                I have also various certifications in ReactJS and Git.I have done Deloitte Technology Consulting Virtual Internship where I have learnt about Deloitte’s Cloud Engineering,tasks,strategies. <br/>
    
            

I enjoy being challenged and engaging with projects that require me to work outside my comfort and knowledge set, as continuing to learn new languages and development techniques are important to me and the success of an organization.

                
                A few skills I would like to highlight: 
                <br/>
                <br/>
               


1. Highly skilled in designing, testing, and developing software.
<br/>
                <br/>
                <br/>
  2.  Thorough understanding of data structures and algorithms.
  <br/>
                <br/>
                <br/>
3.Knowledgeable Machine Learning algorithms. <br/>
                <br/>
                <br/>
4.Experience in front end technologies as well.
<br/>
                <br/>
                <br/>
</h5>
        </div>
        )
    }
}

export default About;